import { render } from "./PropertyDisposalStages.vue?vue&type=template&id=1b673050&scoped=true"
import script from "./PropertyDisposalStages.vue?vue&type=script&lang=js"
export * from "./PropertyDisposalStages.vue?vue&type=script&lang=js"

import "./PropertyDisposalStages.vue?vue&type=style&index=0&id=1b673050&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b673050"]])

export default __exports__